module.exports = __webpack_public_path__ + "static/media/18ECA26.e2c95980.jpg";